import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfomodalComponent } from 'src/app/main/shared/infomodal/infomodal.component';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { ColdwaveDataService } from '../../coldwave-data.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-coldwave-sidebar',
  templateUrl: './coldwave-sidebar.component.html',
  styleUrls: ['./coldwave-sidebar.component.scss']
})
export class ColdwaveSidebarComponent implements OnInit {
  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();
  queryParams:any;
  isInitialLoad: boolean = false;
  dateIndexLength: number;
  activeRadioList: boolean[] = [];
  selectedSource: string;
  selected: any;
  modalRef: any;
  sourceOptions: any = ['IMD', 'ECMWF'];

  sourceMapping = {
    'IMD': 'IMD_LONG_RANGE',
    'ECMWF': 'ECMWF'
  };
  stateList: any[] = [];
  selectedStateUUID: string = '';
  isChecked: boolean = false;
  enableSchoolAlert: boolean = false;
  enableAnganwadi: boolean = false;
  enableHealthCare: boolean = false;
  isCheckedAnganwadi: boolean = false;
  isCheckedHealthCare: boolean = false;
  isCheckedAgriMask: boolean = false;
  enableAgriMask: boolean = false;
  isCheckedWheatMask: boolean = false;
  enableWheatMask: boolean = false;
  isCheckedWindLayer: boolean = true

  constructor(private gisUtils: UtilsService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal, private coldwaveDataSrv: ColdwaveDataService, private toastr: ToastrService ) {
    this.selected = this.router.url.split("/")[2]
  }
  // ngOnInit() {
  //   this.route.queryParamMap.subscribe((params: Params) => {
  //     this.queryParams = {};
  //     for (const param in params) {
  //       if (params.hasOwnProperty(param)) {
  //         this.queryParams = params[param];
  //       }
  //     }
  //     if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
  //       this.isInitialLoad = true
  //       this.selectedSource = this.queryParams['source'] == 'IMD_LONG_RANGE' ? 'IMD' : 'ECMWF'
  //       // if (this.blockNum == 3) {
  //       //   this.dateIndexLength = 10
  //       // } else {
  //       this.dateIndexLength = 7
  //       // }
  //       for (let i = 0; i < this.dateIndexLength; ++i) {
  //         if (i === this.blockNum) {
  //           this.activeRadioList.push(true);
  //         } else {
  //           this.activeRadioList.push(false);
  //         }
  //       }
  //       this.requestSelectedFilterParams()
  //     }
  //   })
  // }
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
      this.selectedSource =
        this.queryParams['source'] === 'ECMWF' ? 'ECMWF' : 'IMD';

      this.loadStates();

      this.isInitialLoad = true;

      this.dateIndexLength = this.selectedSource === 'IMD' ? 7 : 45;
      this.selectedStateUUID = this.queryParams['locType'] == 'COUNTRY' ? '' : this.queryParams['pUUID']
      this.activeRadioList = [];
      for (let i = 0; i < this.dateIndexLength; i++) {
        this.activeRadioList.push(i === this.blockNum);
      }
      this.requestSelectedFilterParams()
      if (this.queryParams.locType == 'DISTRICT') {
        this.enableSchoolAlert = true
        this.enableAnganwadi = true
        this.enableHealthCare = true
        this.enableAgriMask = true
        this.enableWheatMask = true
      // } else if (this.queryParams.locType === 'STATE') {
      //   this.enableWheatMask = true;
      } else {
        this.resetVariables()
      }
    })
  }

  resetVariables() {
    this.isChecked = false
    this.isCheckedAnganwadi = false
    this.isCheckedHealthCare = false
    this.enableSchoolAlert = false
    this.enableAnganwadi = false
    this.enableHealthCare = false
    this.isCheckedAgriMask = false;
    this.enableAgriMask = false;
    this.isCheckedWheatMask = false;
    this.enableWheatMask = false;
    this.gisUtils.cwschoolCheckBoxClicked.next(false)
    this.gisUtils.cwCheckBoxAngaClicked.next(false)
    this.gisUtils.cwCheckBoxHealthCareClicked.next(false)
    this.gisUtils.cwCheckBoxAgriMaskClicked.next(false)
    this.gisUtils.cwCheckBoxWheatMaskClicked.next(false)
    // this.gisUtils.cwWindLayerToggle.next(false)
  }

  ngOnChanges(change: SimpleChanges) {
    let timeStamp = this.labelStrings[this.blockNum].groupName;
    this.gisUtils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      if (change.blockNum.currentValue) {
        this.buttonClicked(change.blockNum.currentValue);
      }

    } else {
      this.buttonClicked(this.blockNum);
    }
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < this.dateIndexLength; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  // buttonClicked(blockNumber, from?: string) {
  //   if (from === 'HTML') {
  //     this.playPos.emit(blockNumber);
  //   }
  //   if (this.activeRadioList[blockNumber]) {
  //     this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
  //   }
  // }
  // buttonClicked(blockNumber: any, from?: string) {

  // if (!this.labelStrings || !this.labelStrings[blockNumber]) {
  //   console.warn('LabelStrings not ready for block:', blockNumber);
  //   return;
  // }

  // this.activeRadioList = this.activeRadioList.map((_, i) => i === blockNumber);

  // const groupName = this.labelStrings[blockNumber].groupName;


  // this.gisUtils.setIndex(groupName);

  //   if (from === 'HTML') {
  //     this.playPos.emit(blockNumber);
  //   }
  //   //  if (this.activeRadioList[blockNumber]) {
  //   //   this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
  //   // }
  // }


 buttonClicked(blockNumber: number, from?: string) {
  let groupName: any = null;

  if (
    this.labelStrings &&
    this.labelStrings[blockNumber] &&
    this.labelStrings[blockNumber].groupName
  ) {
    groupName = this.labelStrings[blockNumber].groupName;
  }

  if (!groupName) {
    console.warn('Invalid groupName for block:', blockNumber);
    return;
  }

  this.gisUtils.coldwaveIndex$.next(groupName);

  if (from === 'HTML') {
    this.playPos.emit(blockNumber);
  }

  this.activeRadioList = this.activeRadioList.map(
    (_, i) => i === blockNumber
  );
}


  //  buttonClicked(blockNumber, from?: string) {
  //   if (from === 'HTML') {
  //     this.playPos.emit(blockNumber);
  //   }
  //   if (this.activeRadioList[blockNumber]) {
  //     this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
  //   }
  // }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['fullLabel'];
    }
  }

  // requestSelectedFilterParams() {
  //   let currentUrlParams: any = {};
  //   // if (!this.isInitialLoad) {
  //   //   currentUrlParams = this.selectedParams;
  //   // }
  //   currentUrlParams['component'] = 'COLDWAVE';
  //   currentUrlParams['src'] = 'IMD_GRID'
  //   if (this.isInitialLoad) {
  //     currentUrlParams['actionType'] = 'filter';
  //     currentUrlParams['view'] = 'ADMIN';
  //     currentUrlParams['pType'] = 'COUNTRY';
  //     currentUrlParams['cType'] = 'STATE';
  //     currentUrlParams['parentLoc'] = 'COUNTRY';
  //     currentUrlParams['dashboardView'] = 'INDIA';
  //     this.gisUtils.selectedParams.next(currentUrlParams);
  //     this.isInitialLoad = false
  //   }
  // }
  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'COLDWAVE';
    currentUrlParams['source'] = this.sourceMapping[this.selectedSource || 'IMD'];
    currentUrlParams['src'] = 'IMD_GRID';
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

  infoclick(value) {
    this.modalRef = this.modalService.open(InfomodalComponent, { backdrop: 'static', keyboard: true, windowClass: 'backgroundTransparent  infocomponent' })
    this.modalRef.componentInstance.selected = value;
  }

  // sourceChange() {
  //   let options: any = { ...this.queryParams };

  //   options['source'] = this.sourceMapping[this.selectedSource];
  //   options['locType'] = 'COUNTRY';
  //   options['pUUID'] = '00cb31c7-2928-4e6d-adcc-443d478c90d6';
  //   options['locName'] = 'India';
  //   options['location'] = 'India##00cb31c7-2928-4e6d-adcc-443d478c90d6';

  //   this.router.navigate(['/coldwatches/coldwave/akbm'], {
  //     queryParams: options,
  //     queryParamsHandling: 'merge'
  //   });

  //   this.isInitialLoad = true;
  //   this.loadStates();
  //   this.requestSelectedFilterParams();
  // }

  sourceChange() {
    let options: any = { ...this.queryParams };

    options['source'] = this.sourceMapping[this.selectedSource];

    this.router.navigate(['/coldwatches/coldwave/akbm'], {
      queryParams: options,
      relativeTo: this.route,
      queryParamsHandling: 'merge'
    });
  }

  onStateSelect() {
    if (!this.selectedStateUUID) return;

    const selectedState = this.stateList.find(
      s => s.uuid === this.selectedStateUUID
    );

    let options: any = { ...this.queryParams };

    options['locType'] = 'STATE';
    options['pUUID'] = selectedState.uuid;
    options['locName'] = selectedState.name;
    options['source'] = this.sourceMapping[this.selectedSource || 'IMD'];

    options['location'] =
      'India##00cb31c7-2928-4e6d-adcc-443d478c90d6' +
      '&' +
      selectedState.name + '##' + selectedState.uuid;

    this.router.navigate(['/coldwatches/coldwave/akbm'], {
      queryParams: options,
      relativeTo: this.route,
      queryParamsHandling: 'merge'
    });

    this.isInitialLoad = true;
    this.requestSelectedFilterParams();
  }


  loadStates() {
    const postData = {
      component: 'COLDWAVE',
      sUUID: '00cb31c7-2928-4e6d-adcc-443d478c90d6',
      pUUID: '00cb31c7-2928-4e6d-adcc-443d478c90d6',
      pType: 'COUNTRY',
      cType: 'STATE',
      countLocationType: 'DISTRICT',
      source: this.sourceMapping[this.selectedSource || 'IMD'],
      startTs: new Date().getTime(),
      endTs: new Date().getTime() + (6 * 24 * 60 * 60 * 1000)
    };
    this.coldwaveDataSrv.getTableDistrictData(postData)
      .subscribe((data: any) => {
        this.stateList = Object.keys(data).map(key => ({
          uuid: data[key].uuid,
          name: this.gisUtils.titleCase(data[key].name)
        }));
      });
  }

    toggleSchoolCheckbox(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isChecked = checkbox.checked;
    if (!this.enableSchoolAlert) {
      event.preventDefault();
      // this.showMessage = true;
    } else {
      // this.showMessage = false;
      this.isChecked = (event.target as HTMLInputElement).checked;
    }
    this.gisUtils.cwschoolCheckBoxClicked.next(this.isChecked);
    this.isCheckedAnganwadi = false
    this.isCheckedHealthCare = false
    this.gisUtils.cwCheckBoxAngaClicked.next(false)
    this.gisUtils.cwCheckBoxHealthCareClicked.next(false);
  }

  toggleCheckboxAnganwadi(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isCheckedAnganwadi = checkbox.checked;
    if (!this.enableAnganwadi) {
      event.preventDefault();
      // this.showMessage = true;
    } else {
      // this.showMessage = false;
      this.isCheckedAnganwadi = (event.target as HTMLInputElement).checked;
    }
    this.gisUtils.cwCheckBoxAngaClicked.next(this.isCheckedAnganwadi);
    this.isChecked = false
    this.isCheckedHealthCare = false
    this.gisUtils.cwschoolCheckBoxClicked.next(false);
    this.gisUtils.cwCheckBoxHealthCareClicked.next(false);

  }

  toggleCheckboxHealthCare(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isCheckedHealthCare = checkbox.checked;
    if (!this.enableHealthCare) {
      event.preventDefault();
      // this.showMessage = true;
    } else {
      // this.showMessage = false;
      this.isCheckedHealthCare = (event.target as HTMLInputElement).checked;
    }
    this.gisUtils.cwCheckBoxHealthCareClicked.next(this.isCheckedHealthCare);
    this.isCheckedAnganwadi = false
    this.isChecked = false
    this.gisUtils.cwCheckBoxAngaClicked.next(false);
    this.gisUtils.cwschoolCheckBoxClicked.next(false);
  }

  showMessage(type) {
    if (!this.enableSchoolAlert || !this.enableAnganwadi || !this.enableHealthCare) {
      this.toastr.info("Go to Block Level for " + type)
    }
  }
 showMessageWheatMask(type: string) {
  if (!this.enableWheatMask) {
    this.toastr.info('Go to Block Level for ' + type);
  }
}
onWheatMaskClick(event: MouseEvent) {
  if (!this.enableWheatMask) {
    event.preventDefault();
    event.stopPropagation();
    this.showMessageWheatMask('Wheat Mask');
  }
}
toggleCheckboxAgriMask(event) {
  const checkbox = event.target as HTMLInputElement;
  this.isCheckedAgriMask = checkbox.checked;

  if (!this.enableAgriMask) {
    event.preventDefault();
    return;
  }

  this.gisUtils.cwCheckBoxAgriMaskClicked.next(this.isCheckedAgriMask);

  this.isChecked = false;
  this.isCheckedAnganwadi = false;
  this.isCheckedHealthCare = false;

  this.gisUtils.cwschoolCheckBoxClicked.next(false);
  this.gisUtils.cwCheckBoxAngaClicked.next(false);
  this.gisUtils.cwCheckBoxHealthCareClicked.next(false);
}

// toggleCheckboxWheatMask(event) {
//   const checkbox = event.target as HTMLInputElement;
//   this.isCheckedWheatMask = checkbox.checked;

//   if (!this.enableWheatMask) {
//     event.preventDefault();
//     return;
//   }

//   this.gisUtils.cwCheckBoxWheatMaskClicked.next(this.isCheckedWheatMask);

//   this.isChecked = false;
//   this.isCheckedAnganwadi = false;
//   this.isCheckedHealthCare = false;
//   this.isCheckedAgriMask = false;
//   this.gisUtils.cwschoolCheckBoxClicked.next(false);
//   this.gisUtils.cwCheckBoxAngaClicked.next(false);
//   this.gisUtils.cwCheckBoxHealthCareClicked.next(false);
//   this.gisUtils.cwCheckBoxAgriMaskClicked.next(false);
// }
  toggleCheckboxWheatMask(event) {
  const checkbox = event.target as HTMLInputElement;
  this.isCheckedWheatMask = checkbox.checked;

  this.gisUtils.cwCheckBoxWheatMaskClicked.next(this.isCheckedWheatMask);

  this.isChecked = false;
  this.isCheckedAnganwadi = false;
  this.isCheckedHealthCare = false;
  this.isCheckedAgriMask = false;
  this.gisUtils.cwschoolCheckBoxClicked.next(false);
  this.gisUtils.cwCheckBoxAngaClicked.next(false);
  this.gisUtils.cwCheckBoxHealthCareClicked.next(false);
  this.gisUtils.cwCheckBoxAgriMaskClicked.next(false);
}

  toggleCheckboxWindLayer(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isCheckedWindLayer = checkbox.checked
    this.gisUtils.cwWindLayerToggle.next(this.isCheckedWindLayer)
  }
  ngOnDestroy(): void {
  // this.gisUtils.setIndex(null);
  }
}
